@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.resources {
  &Form {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 10px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid map.get(core.$colors, lightBlue);
    margin-bottom: 16px;
  }

  .serverError {
    padding-bottom: 16px;
  }
}
